export const getApiEntrypoint = () =>
  localStorage.getItem('app_api_entrypoint') ?? process.env.REACT_APP_API_ENTRYPOINT;

export const getHostName = () => {
  const apiEnding = 'api';
  if (getApiEntrypoint()?.endsWith(apiEnding)) {
    return getApiEntrypoint()?.replace(/api$/, '');
  } else {
    return getApiEntrypoint();
  }
};
